import {Injectable, Injector} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import {BaseResourceService} from '@sicapes/core';
import {InstituicaoEnsinoModel} from '../../models/corporativo/instituicao-ensino.model';
import {PpgModel} from '../../models/curso/ppg.model';
import {HttpClient, HttpParams} from '@angular/common/http';

class ISucupira {
    id?: number;

    static fromJson(jsonData: any): ISucupira {
        return Object.assign(new ISucupira(), jsonData);
    }
}

@Injectable({
    providedIn: 'root'
})
export class SucupiraService extends BaseResourceService<ISucupira> {

    constructor(protected injector: Injector, private readonly httpClient: HttpClient) {
        super('/rest/sucupira', injector, ISucupira.fromJson);
    }

    public obterNotaPPG(ies: InstituicaoEnsinoModel, ppg: PpgModel): Observable<any> {
        let url = this.apiPath + '/pro-reitores-ppgs/' + ies.id;

        if (ppg !== null && typeof ppg !== 'undefined') {
            url += '/programa/' + ppg.id;
        }

        return this.http.get(url, {}).pipe(
            map(this.jsonDataToResource.bind(this)),
            catchError(this.handleError)
        );
    }


    public obterProReitorPPG(ies: InstituicaoEnsinoModel): Observable<any> {
        const url = this.apiPath + '/pro-reitores-ppgs/' + ies.id;
        return this.http.get(url, {}).pipe(
            map(this.jsonDataToResource.bind(this)),
            catchError(this.handleError)
        );
    }

    public obterProReitor(ies: InstituicaoEnsinoModel): Observable<any> {
        const url = this.apiPath + '/pro-reitores/' + ies.id;
        return this.http.get(url, {}).pipe(
            map(this.jsonDataToResource.bind(this)),
            catchError(this.handleError)
        );
    }

    public obterPPGs(id_ies_capes: number): Observable<any> {
        const url = this.apiPath = 'rest/sucupira/ppg-curso-instituicao/'+ id_ies_capes;
        return this.http.get(this.apiPath);
    }

    public obterDocentePPGs(cpf: string): Observable<any> {
        const url = this.apiPath + '/docente-ppg/' + cpf;
        return this.http.get(url, {}).pipe(
            map(this.jsonDataToResource.bind(this)),
            catchError(this.handleError)
        );
    }

    public obterCoordenadorPPGs(ies: InstituicaoEnsinoModel): Observable<any> {
        const url = this.apiPath + '/coordenadores-ppgs/' + ies.id;
        return this.http.get(url, {}).pipe(
            map(this.jsonDataToResource.bind(this)),
            catchError(this.handleError)
        );
    }

    /**
     * @param cpf The CPF of the person
     * @param situacao The situation of the person (1: Matriculado, 2: Titulado, 3: Desligado, 4: Abandonou, 5: Mudan a de N vel sem Defesa, 6: Mudan a de N vel com Defesa)
     * @returns An Observable of the discente of the person
     */
    public obterDiscente(cpf: string, situacao = 1): Observable<any> {
        const url = this.apiPath + '/discente/' + cpf + '/situacao/' + situacao;
        return this.http.get(url, {}).pipe(
            map(this.jsonDataToResource.bind(this)),
            catchError(this.handleError)
        );
    }

    public obterPPGUnificados(idInstituicaoEnsino: number): Observable<any> {
        const url = this.apiPath + '/ppg-unificado/' + idInstituicaoEnsino;
        return this.httpClient.get(url).pipe(
            catchError(error => {
                return throwError(error);
            }),
            take(1)
        );
    }

    public obterPPGUnificadosPorAreas(
        idInstituicaoEnsino: number,
        areasAvaliacao: string[],
        programasModalidade: string[],
        ano: number = new Date().getFullYear()
    ): Observable<any> {
        const url = this.apiPath + '/ppg-unificado-por-areas/' + idInstituicaoEnsino;
        let params = new HttpParams().set('ano', String(ano));

        areasAvaliacao.forEach(area => {
            params = params.append('areasAvaliacao[]', area);
        });
        programasModalidade.forEach(programa => {
            params = params.append('programasModalidade[]', programa);
        });

        return this.httpClient.get(url, {params}).pipe(
            catchError(error => throwError(error)),
            take(1)
        );
    }
}
